module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/5@2x_216964bb76127039301fc9ee175d0b46.png";